// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import type { RecommendedArticleType } from '../types';
import ResponsiveImage from '../../../../internal/ResponsiveImage';

export default (props: { articles: Array<RecommendedArticleType> }) => (
  <div className={styles.container}>
    {props.articles.map((article, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className={styles.article} key={index}>
        <ResponsiveImage
          className={styles.image}
          src={article.image}
          alt={article.alt}
          defaultSize={{ width: 90, height: 90 }}
        />
        <div className={styles.content}>
          <p className={styles.category}>{article.category}</p>
          <h3>
            <a href={article.href} className={styles.title}>
              {article.title}
            </a>
          </h3>
        </div>
      </div>
    ))}
  </div>
);
